export default __webpack_public_path__ + "static/media/title.a9d1cdad.svg";